import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type TagProps = ComponentProps<typeof Tag>;

export const Tag = styled("span", {
  // Reset
  boxSizing: "border-box",
  display: "inline-flex",

  // Custom
  borderRadius: "$pill",
  fontWeight: 700,
  fontSize: "$xs",
  lineHeight: "100%",
  alignItems: "center",
  gap: "$2",
  fill: "CurrentColor",

  variants: {
    size: {
      sm: {
        p: "$1 $2",
      },
      md: {
        p: "$2",
      },
    },
    variant: {
      info: {
        color: "$neutrals-white",
        backgroundColor: "$primary-600",
        border: "1px solid $neutrals-white",
      },
      "info-light": {
        color: "$primary-600",
        backgroundColor: "$primary-100",
        border: "1px solid $primary-600",
      },
      success: {
        color: "$neutrals-white",
        backgroundColor: "$success-600",
        border: "1px solid $neutrals-white",
      },
      "success-light": {
        color: "$success-600",
        backgroundColor: "$success-100",
        border: "1px solid $success-600",
      },
      warning: {
        color: "$neutrals-white",
        backgroundColor: "$warning-600",
        border: "1px solid $neutrals-white",
      },
      "warning-dark": {
        color: "$neutrals-white",
        backgroundColor: "$warning-700",
      },
      "warning-light": {
        color: "$warning-600",
        backgroundColor: "$warning-100",
        border: "1px solid $warning-600",
      },
      error: {
        color: "$neutrals-white",
        backgroundColor: "$danger-600",
        border: "1px solid $neutrals-white",
      },
      "warning-dark-light": {
        color: "$warning-dark",
        backgroundColor: "$warning-dark-light",
        border: "1px solid $warning-dark",
      },
      "error-light": {
        color: "$danger-600",
        backgroundColor: "$danger-100",
        border: "1px solid $danger-600",
      },
      neutral: {
        color: "$neutrals-white",
        backgroundColor: "$neutrals-dark",
        border: "1px solid $neutrals-white",
      },
      "neutral-light": {
        color: "$neutrals-darkest",
        backgroundColor: "$neutrals-lightest",
        border: "1px solid $neutrals-darkest",
      },
      "neutral-dark": {
        color: "$neutrals-white",
        backgroundColor: "#1B1B1B29",
        border: "1px solid $neutrals-white",
      },
      "neutral-darkest": {
        backgroundColor: "$neutrals-darkest",
        border: "1px solid $neutrals-darkest",
        color: "$neutrals-white",
      },
      "neutral-gray": {
        backgroundColor: "$neutrals-gray",
        border: "1px solid $neutrals-gray",
        color: "$neutrals-white",
      },
      "neutral-600": {
        color: "$neutral-600",
        backgroundColor: "transparent",
        border: "1px solid $neutral-600",
      },
    },
  },

  defaultVariants: {
    variant: "neutral",
    size: "md",
  },
});

Tag.displayName = "Tag";
